module.exports = __webpack_public_path__ + "static/img/jieshao.62ce23b6.png";